export default "__VITE_ASSET__BzkBISKH__"